import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { WxLabel, WxText } from '../..';
import useMenu from '../../../hooks/api/queries/useMenu';
import { useMenuContext } from '../../../hooks/context/useMenuContext';
import { __ } from '../../../i18n/l10n';
import { breakpoint } from '../../../styles/constants';
import { appendCommitHash } from '../../../utils/appendHash';

export const SubMenu: React.FC = () => {
  const { setOpen, selected } = useMenuContext();
  const { data } = useMenu();

  if (!data) return null;
  return (
    <Background>
      <List>
        <li>
          <Link
            to={appendCommitHash(`/category/${data[selected].slug}`)}
            onClick={() => setOpen(false)}
          >
            <WxLabel label={__('See all')} black hover />
          </Link>
        </li>
        {data[selected]?.children.map((item, index) => (
          <li style={{}} key={`li-${index}`} onClick={() => setOpen(false)}>
            <Link to={appendCommitHash(`/category/${item.slug}`)}>
              <WxText text={item.name} hover />
            </Link>
          </li>
        ))}
      </List>
    </Background>
  );
};

const Background = styled.div`
  background-color: ${({ theme }) => theme.colors.white};
`;

const List = styled.ul`
  font-size: 1.4rem;
  padding-top: 1.1rem;

  @media (min-width: ${breakpoint}) {
    padding-top: 0;
  }
  span {
    color: ${({ theme }) => theme.colors.black};
  }

  li {
    width: fit-content;
    margin-bottom: 0.625rem;
  }

  :first-child {
    margin-bottom: 0.75rem;
  }
`;
